/** React-registered Clerk session surface for `clerk-auth-recovery.service.ts` (see that module header). */
export type ClerkAuthRecoverySession = {
  isEligible: () => boolean;
  clearCache: () => void;
  getToken: () => Promise<string | null>;
};

type Registration = {
  generation: number;
  session: ClerkAuthRecoverySession;
};

let generation = 0;
let activeRegistration: Registration | null = null;

export function registerClerkAuthRecoverySession(session: ClerkAuthRecoverySession): () => void {
  generation += 1;
  const registration: Registration = { generation, session };
  activeRegistration = registration;

  return () => {
    if (activeRegistration?.generation === registration.generation) {
      activeRegistration = null;
    }
  };
}

export function getClerkAuthRecoverySession(): ClerkAuthRecoverySession | null {
  return activeRegistration?.session ?? null;
}

/** Test-only reset for registry isolation. */
export function resetClerkAuthRecoverySessionRegistryForTests(): void {
  generation = 0;
  activeRegistration = null;
}
